import React from 'react';

export const DeleteTarget = () => {
  return (
    <button
      type="button"
      className="target-delete-definition"
      data-test="DeleteTarget"
    >
      Delete
    </button>
  );
};
